import { ElementRef } from '@angular/core';
import { HoldingsOverlapService } from 'SecuritiesApp/ts/services/holdings-overlap.service';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/holdings-overlap.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../charts/static/charts/ts/features/pie-chart/pie-chart.component";
const _c0 = () => [];
function TopHoldingsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵlistener("click", function TopHoldingsComponent_div_4_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.editHoldingsRedirect()); });
    i0.ɵɵtext(3, "Edit Holdings");
    i0.ɵɵelementEnd()()();
} }
function TopHoldingsComponent_ycn_pie_chart_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-pie-chart", 16);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("chartDataJsonInput", ctx_r1.chartDataJson);
} }
function TopHoldingsComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "No data available");
    i0.ɵɵelementEnd();
} }
function TopHoldingsComponent_tbody_19_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 19)(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 10);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const holding_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", holding_r3.symbol);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", holding_r3.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r3.weighting);
} }
function TopHoldingsComponent_tbody_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, TopHoldingsComponent_tbody_19_tr_1_Template, 7, 3, "tr", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.topHoldings);
} }
function TopHoldingsComponent_tbody_20_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function TopHoldingsComponent_tbody_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 20);
    i0.ɵɵtemplate(1, TopHoldingsComponent_tbody_20_tr_1_Template, 7, 0, "tr", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(4));
} }
export class TopHoldingsComponent {
    constructor(eltRef, holdingsOverlapService) {
        this.eltRef = eltRef;
        this.holdingsOverlapService = holdingsOverlapService;
        this.limit = 10;
        this.title = '';
        this.editHoldingsUrl = '';
        this.topHoldings = [];
        this.pieChartData = [];
        this.chartDataJson = '';
        this.tableHasNoData = true;
        this.loading = true;
    }
    ngOnInit() {
        if (this.title.length === 0) {
            this.title = `Top ${this.limit} Holdings ${this.displaySecurityId}`;
        }
        this.getTopHoldings();
    }
    editHoldingsRedirect() {
        window.location.href = this.editHoldingsUrl;
    }
    getTopHoldings() {
        this.loading = true;
        this.holdingsOverlapService.getTopHoldings(this.securityId, this.limit, this.holdingsLayer).subscribe({
            next: (response) => {
                this.topHoldings = response.holdings_data;
                this.pieChartData = response.chart_data;
                this.chartDataJson = JSON.stringify({
                    chart_data: this.pieChartData,
                });
                this.tableHasNoData = this.topHoldings.length === 0;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.tableHasNoData = true;
            },
        });
    }
}
TopHoldingsComponent.ɵfac = function TopHoldingsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopHoldingsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HoldingsOverlapService)); };
TopHoldingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopHoldingsComponent, selectors: [["ycn-top-holdings"]], inputs: { securityId: "securityId", displaySecurityId: "displaySecurityId", securityType: "securityType", limit: "limit", holdingsLayer: "holdingsLayer", title: "title", editHoldingsUrl: "editHoldingsUrl" }, standalone: false, decls: 21, vars: 6, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], ["class", "panel-actions", 4, "ngIf"], [1, "panel-content"], [1, "chart-wrap"], [1, "chart-pie"], [3, "chartDataJsonInput", 4, "ngIf"], ["class", "panel-data-empty-message ajust-vertical", "data-test-id", "no-data-available-message", 4, "ngIf"], [1, "table"], [1, "text-right"], [4, "ngIf"], ["data-test-id", "no-data-default-table", 4, "ngIf"], [1, "panel-actions"], [1, "panel-action"], [1, "btn", "btn-text", 3, "click"], [3, "chartDataJsonInput"], ["data-test-id", "no-data-available-message", 1, "panel-data-empty-message", "ajust-vertical"], ["data-test-id", "top-holdings-row-item", 4, "ngFor", "ngForOf"], ["data-test-id", "top-holdings-row-item"], ["data-test-id", "no-data-default-table"], [4, "ngFor", "ngForOf"]], template: function TopHoldingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, TopHoldingsComponent_div_4_Template, 4, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6);
        i0.ɵɵtemplate(8, TopHoldingsComponent_ycn_pie_chart_8_Template, 1, 1, "ycn-pie-chart", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, TopHoldingsComponent_div_9_Template, 2, 0, "div", 8);
        i0.ɵɵelementStart(10, "table", 9)(11, "thead")(12, "tr")(13, "th");
        i0.ɵɵtext(14, "Symbol");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "th");
        i0.ɵɵtext(16, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "th", 10);
        i0.ɵɵtext(18, "%\u00A0Weight");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(19, TopHoldingsComponent_tbody_19_Template, 2, 1, "tbody", 11)(20, TopHoldingsComponent_tbody_20_Template, 2, 2, "tbody", 12);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.editHoldingsUrl.length > 0);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", !ctx.tableHasNoData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.PieChartComponent], encapsulation: 2 });
